var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1310",
    transform: "translate(-857 -220)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 14",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(857 220)",
    style: {
      fill: "#edf6ee"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 138"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 115",
    d: "M208.5 4.015h-.969V1.987a1.391 1.391 0 0 0-2.782 0v2.028h-8.472V1.987a1.391 1.391 0 0 0-2.782 0v2.028h-.969a5.848 5.848 0 0 0-5.842 5.842v14.5a5.848 5.848 0 0 0 5.842 5.842h20.425a1.391 1.391 0 0 0 1.391-1.391V9.857a5.849 5.849 0 0 0-5.842-5.842M192.531 6.8H208.5a3.064 3.064 0 0 1 3.06 3.06v1.768h-22.089V9.857a3.063 3.063 0 0 1 3.06-3.06m0 20.622a3.064 3.064 0 0 1-3.06-3.06v-9.952h22.094v13.012z",
    transform: "translate(685.624 233.459)",
    style: {
      fill: "#00402e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 116",
    d: "M198.7 29.741h-1.3a1.391 1.391 0 0 0 0 2.782h1.3a1.391 1.391 0 1 0 0-2.782",
    transform: "translate(681.489 220.53)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 117",
    d: "M210.566 29.741h-1.3a1.391 1.391 0 1 0 0 2.782h1.3a1.391 1.391 0 1 0 0-2.782",
    transform: "translate(676.226 220.53)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 118",
    d: "M222.43 29.741h-1.3a1.391 1.391 0 0 0 0 2.782h1.3a1.391 1.391 0 0 0 0-2.782",
    transform: "translate(670.963 220.53)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 119",
    d: "M198.7 38.9h-1.3a1.391 1.391 0 0 0 0 2.782h1.3a1.391 1.391 0 1 0 0-2.782",
    transform: "translate(681.489 216.466)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 120",
    d: "M210.566 38.9h-1.3a1.391 1.391 0 1 0 0 2.782h1.3a1.391 1.391 0 1 0 0-2.782",
    transform: "translate(676.226 216.466)",
    style: {
      fill: "#00a61c"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar);
export default __webpack_public_path__ + "static/media/ico-calendar.5a839f526ee1b33fc8d912ed1eb1abf7.svg";
export { ForwardRef as ReactComponent };